/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const DeletedFile = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M2.5 9.6875V3.4375C2.50205 3.02373 2.66733 2.6275 2.95991 2.33491C3.2525 2.04233 3.64873 1.87705 4.0625 1.875H12.1875C12.4359 1.8769 12.6739 1.97489 12.8516 2.14844L17.2266 6.52344C17.4001 6.70113 17.4981 6.93913 17.5 7.1875V9.6875C17.5 9.93614 17.4012 10.1746 17.2254 10.3504C17.0496 10.5262 16.8111 10.625 16.5625 10.625C16.3139 10.625 16.0754 10.5262 15.8996 10.3504C15.7238 10.1746 15.625 9.93614 15.625 9.6875V8.75H11.5625C11.3139 8.75 11.0754 8.65123 10.8996 8.47541C10.7238 8.2996 10.625 8.06114 10.625 7.8125V3.75H4.375V9.6875C4.375 9.93614 4.27623 10.1746 4.10041 10.3504C3.9246 10.5262 3.68614 10.625 3.4375 10.625C3.18886 10.625 2.9504 10.5262 2.77459 10.3504C2.59877 10.1746 2.5 9.93614 2.5 9.6875ZM12.5 4.45312V6.875H14.9219L12.5 4.45312Z"
        fill="#DE3434"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3033 13.7175L5.65165 16.3692L7.06586 17.7834L9.71751 15.1317L12.3692 17.7834L13.7834 16.3692L11.1317 13.7175L13.7834 11.0659L12.3692 9.65165L9.71751 12.3033L7.06586 9.65165L5.65165 11.0659L8.3033 13.7175Z"
        fill="#DE3434"
      />
    </BaseSvgIcon>
  )
}

export default DeletedFile
